/*global _ */
import {name, mixins, props, data, EventBus} from './config'

export default {
  name,
  mixins,
  props,

  data() {
    return {
      ...data,
    }
  },

  watch: {
    playcards(val) {
      this.cardsList = this.parseCards(val)
    }
  },
  computed: {
  },
  methods: {
    registerEventListeners() {
    },
    parseCardMoreAbilities(card, cards) {
      const mixin = this
      card.$can = {
        ...(card.$can || {}),
        ...{
          setPrimary: this.allowSetPrimary && !card.is_primary,
        }
      }
      card.$actions = {
        ...(card.$actions || {}),
        ...{
          primary: async () => await mixin.primary(card)
        }
      }

      return card
    },

    async addPlayCard(fields) {
      this.playcard.number = fields.number
      this.playcard.cvv = fields.cvv
      await this.add()
    },
    recoverByEmail(payload) {
      this.$emit('recoverByEmail', payload)
      EventBus.$emit('playcard.recover-by-email', payload)
    },
    recoverByNumber(payload) {
      this.$emit('recoverByNumber', payload)
      EventBus.$emit('playcard.recover-by-number', payload)
    }
  },
}
